var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSwatches = function SvgIconSwatches(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.931 15.944a1 1 0 1 0-1.969-.35L5.765 16.7a1 1 0 0 0 1.97.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.071 21.2q.418.065.836.05h12.968a1.75 1.75 0 0 0 1.75-1.75v-4.043a1.75 1.75 0 0 0 .008-1.196l-.003-.007-1.798-4.926-.001-.003a1.75 1.75 0 0 0-2.25-1.049l-.003.002-5.198 1.89.961-5.457.002-.008a1.76 1.76 0 0 0-1.412-2.02l-.01-.002-5.171-.909h-.003a1.74 1.74 0 0 0-2.023 1.425L2.456 16.045c-.42 2.39 1.17 4.762 3.61 5.155zm5.258-16.593L6.65 3.785 4.426 16.392c-.236 1.34.667 2.624 1.956 2.833q.15.023.303.027l.065-.002h.114q.317-.015.617-.113.04-.018.08-.033l.148-.054a2.38 2.38 0 0 0 1.385-1.76l1-5.676a1 1 0 0 1 .03-.172zm8.296 14.643h-6.617l6.617-2.409zm-7.646-6.809-.916 5.198v.003a4 4 0 0 1-.042.203l8.642-3.146-1.628-4.46z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconSwatches;